import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  bookingsDetails: () => ({
    background: theme.colors.formHeaderBackgroundColor,
    padding: '12px',
  }),
  widget: ({ size }) => ({
    padding: size === 'small' ? '8px' : '36px 18px',
  }),
}));

export default useStyles;
